<template>
  <vue-recaptcha
    ref="recaptcha"
    :class="componentClassName"
    :sitekey="recaptchaKey"
    @verify="onVerify"
    @expired="onExpired"
  ></vue-recaptcha>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  name: 'a-verify-recaptcha',
  components: {
    VueRecaptcha,
  },
  props: {
    recaptchaToken: {
      type: String,
      default: '',
    },
  },
  emits: ['update-recaptcha-token'],
  data() {
    return {
      recaptchaKey: document.querySelector('meta[name="recaptcha"]').getAttribute('content'),
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-verify-recaptcha');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    onVerify(response) {
      if (response !== '') {
        //recaptchaTokenをemit
        return this.updateToken(response);
      } else {
        return false;
      }
    },
    onExpired() {
      this.resetRecaptcha();
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
      //recaptchaTokenをemit
      this.updateToken('');
    },
    updateToken(value) {
      this.$emit('update-recaptcha-token', value);
    },
  },
};
</script>
